module.exports = __webpack_public_path__ + "static/media/profile_ines.2013a36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/team/profile_ines.png
// module id = 1123
// module chunks = 4